import { container } from '@shared/common/dependency-injection/domain/container';
import { EstablishmentModuleRoutes } from '@client/feature/establishment/application/routes/establishment.module-routes';

export const establishmentRoutes = new EstablishmentModuleRoutes(container).getRoutes();
